import { JSX } from "react";
import Text from "../../components/Text/Text";
import color from "../../resource/color";
import { TierDefinition } from "../ShopTier/config";

function TierCardPreview({
  tier,
  imageOverride,
  width = 260,
}: {
  tier?: TierDefinition;
  imageOverride?: string;
  width?: number | string;
}): JSX.Element | null {
  if (!tier) return null;
  const src = imageOverride || tier.img;
  if (src) {
    return (
      <img
        src={src}
        alt={tier.label}
        style={{ width, aspectRatio: "16 / 9", borderRadius: 12, objectFit: "cover", border: `1px solid ${color.border}`, display: "block" }}
      />
    );
  }
  return (
    <div
      style={{
        width,
        aspectRatio: "16 / 9",
        borderRadius: 12,
        position: "relative",
        overflow: "hidden",
        background: `linear-gradient(135deg, ${color.Text2} 0%, ${tier.color} 140%)`,
        padding: 16,
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        border: `1px solid ${color.border}`,
        boxSizing: "border-box",
      }}
    >
      <div>
        <Text fontSize={12} color="white" style={{ opacity: 0.7, letterSpacing: 1 }}>SELLCODA TIER</Text>
        <div style={{ marginTop: 4 }}>
          <span
            style={{
              display: "inline-block",
              padding: "2px 8px",
              borderRadius: 999,
              background: "rgba(255,255,255,0.2)",
              fontSize: 11,
              color: "#fff",
              fontWeight: 700,
              letterSpacing: 1,
            }}
          >
            {tier.key.toUpperCase()}
          </span>
        </div>
      </div>
      <Text fontSize={22} fontWeight={700} color="white">{tier.label}</Text>
      <div
        style={{
          position: "absolute",
          right: -10,
          bottom: -16,
          width: 80,
          height: 80,
          borderRadius: "50%",
          border: "3px solid rgba(255,255,255,0.25)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Text fontSize={28} fontWeight={700} color="white" style={{ opacity: 0.35 }}>S</Text>
      </div>
    </div>
  );
}

export default TierCardPreview;
